import styled from 'styled-components';

export const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
`;

export const HeroSection = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 40px;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const LeftColumn = styled.div`
  flex: 1;
  margin-right: 20px;

  @media (max-width: 768px) {
    margin-right: 0;
  }
`;

export const PageTitle = styled.h1`
  font-size: 60px;
  font-weight: 800;
  line-height: 1.27;
  letter-spacing: 0.2px;
  color: #354354;
  margin-bottom: 16px;

  @media (max-width: 768px) {
    font-size: 32px;
  }
`;

export const Subtitle = styled.h2`
  font-size: 32px;
  font-weight: 800;
  letter-spacing: 0.2px;
  color: #354354;
`;

export const Paragraph = styled.p<{ noMargin?: boolean }>`
  font-size: 18px;
  line-height: 1.33;
  letter-spacing: 0.2px;
  color: #354354;
  margin: ${({ noMargin }) => (noMargin ? '0' : '8px 0')};

  & + & {
    margin-top: ${({ noMargin }) => (noMargin ? '0' : '16px')};
  }
`;

export const TextLink = styled.a`
  color: #4a90e2;
  cursor: pointer;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

export const HeroImage = styled.div`
  position: relative;
  max-height: 310px;
  z-index: -1;

  @media (max-width: 768px) {
    margin-left: 0;
    max-width: 360px;
    width: 100%;
  }
`;

export const SearchContainer = styled.div`
  padding: 20px;
  background-color: #fff;
  border-radius: 14px;
`;

export const SearchForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const FormControls = styled.div`
  display: flex;
  align-items: flex-end;

  & > *:last-child {
    margin-left: 20px;

    @media (max-width: 768px) {
      margin-left: 0;
    }
  }

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    max-width: 100%;
    gap: 20px;
  }
`;

export const FormItem = styled.div`
  flex: 1;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const Label = styled.label`
  font-size: 16px;
  font-weight: 600;
  color: #354354;
  margin-bottom: 8px;
  display: block;
`;

export const InputContainer = styled.div`
  position: relative;

  > div {
    margin: 0;
  }
`;

export const Input = styled.input`
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  font-size: 16px;
  background-color: #f4f7f9;
`;

export const IconPlaceholder = styled.div`
  width: 24px;
  height: 24px;
  background-color: #ccc;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 10px;
`;

export const SearchButton = styled.a`
  background-color: ${({ disabled }) => (disabled ? '#ccc' : '#4a90e2')};
  color: #fff;
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  font-weight: 600;
  font-size: 16px;
  cursor: pointer;
  max-height: 48px;
  text-decoration: none;
  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')};
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  transition: 0.1s opacity;
  opacity: 1;

  :hover {
    cursor: pointer;
    color: #fff;
    opacity: 0.8;
    transition: 0.1s opacity;
  }

  @media (max-width: 768px) {
    width: 100%;
    text-align: center;
  }
`;

export const BenefitsBlock = styled.div`
  display: flex;
  justify-content: space-between;
  background-color: #fff;
  border-radius: 12px;
  padding: 40px 70px;
  margin-bottom: 40px;

  @media (max-width: 768px) {
    flex-direction: column;
    padding: 20px;
  }
`;

export const BenefitItem = styled.div`
  width: 33.3333%;
  padding: 0 20px;
  text-align: center;

  @media (max-width: 768px) {
    width: 100%;
    margin-bottom: 20px;
  }
`;

export const BenefitTitle = styled.h3`
  font-size: 20px;
  font-weight: 800;
  color: #354354;
  margin-top: 8px;
`;

export const BenefitText = styled.p`
  font-size: 16px;
  color: #354354;
  margin-top: 8px;
`;

export const TextBlock = styled.div`
  max-width: 760px;
  margin: 0 auto;
  padding: 0 20px;
  margin-bottom: 40px;

  @media (max-width: 768px) {
    padding: 0;
  }
`;

export const Heading2 = styled.h2`
  font-size: 32px;
  font-weight: 800;
  color: #354354;
  margin-bottom: 16px;
  text-align: center;

  @media (max-width: 768px) {
    font-size: 24px;
  }
`;

export const CityListContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
`;

export const CityList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: grid;
  grid-template-columns: repeat(3, 1fr);

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`;

export const CityItem = styled.li`
  padding: 4px 0;
  border-radius: 8px;
  font-size: 16px;
  color: #4a90e2;
`;

export const CityLink = styled.a`
  color: inherit;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
    }
}`;
